import React from 'react';

import {alerta} from 'components/Alert';

// Cores de badge por situação, seguindo o padrão das outras listas do admin
const CORES_SITUACAO = {
    pendente: 'secondary',
    vencedor: 'success',
    perdedor: 'danger',
    cancelado: 'warning',
    pago: 'primary',
};

export function BadgeSituacao({situacao}) {
    return (
        <span className={`badge badge-${CORES_SITUACAO[situacao] || 'secondary'} text-capitalize`}>
            {situacao}
        </span>
    );
}

// 423 = módulo Esportivas não liberado para a banca → esconde a tela.
// Demais erros seguem o envelope {success:false, message} / {message, errors} do alerta.
export function trataErroEsportivas(e, setModuloBloqueado) {
    if (e?.response?.status === 423) {
        setModuloBloqueado(true);
        return;
    }

    if (e?.response?.data) {
        alerta(e.response.data);
    }
}

export function AvisoModuloBloqueado() {
    return (
        <div className="conteudo-principal" style={{padding: 20}}>
            Esportivas não está liberado para sua banca.
        </div>
    );
}
